import { formatMoney } from '@mms/shared';
import dayjs from 'dayjs';
import type { ReactNode } from 'react';

/** The one display format for dates across the UI (native date pickers follow the browser's locale instead). */
export const DATE_FORMAT = 'DD-MM-YYYY';
export const fmtDate = (v: string | null | undefined) => (v ? dayjs(v).format(DATE_FORMAT) : '');
export const fmtDateTime = (v: string | null | undefined) => (v ? dayjs(v).format(`${DATE_FORMAT} hh:mm A`) : '');
/** ISO instant -> value for <input type="datetime-local"> in the browser's zone. */
export const toDateTimeInput = (v: string | null | undefined) => (v ? dayjs(v).format('YYYY-MM-DDTHH:mm') : '');
/** <input type="datetime-local"> value -> ISO string with offset, which the API requires. */
export const fromDateTimeInput = (v: string) => dayjs(v).format();
export const nowInput = () => dayjs().format('YYYY-MM-DDTHH:mm');

/** Right-aligned, tabular money; negative amounts are shown in red. */
export function Amount({ value, decimals = 2, code }: { value: string | number | null | undefined; decimals?: number; code?: string | null }): ReactNode {
  if (value === null || value === undefined || value === '') return <span className="text-body-tertiary">—</span>;
  const negative = Number(value) < 0;
  return (
    <span className={`amount ${negative ? 'text-danger' : ''}`}>
      {formatMoney(value, decimals, decimals)}
      {code ? <small className="text-body-secondary ms-1">{code}</small> : null}
    </span>
  );
}
